// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MapOutlinedSvg from "@fishx/icons-svg/es/asn/MapOutlined";
import FishxIcon from '../components/FishxIcon';

var MapOutlined = function MapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MapOutlinedSvg
  }));
};

MapOutlined.displayName = 'MapOutlined';
export default React.forwardRef(MapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MapOutlined.js
// module id = 3087
// module chunks = 0